import _ from "lodash";
import store from "services/redux/store";
import { setData } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchBookingInvitationSent from "utils/fetch/FetchBookingInvitationSent";
import HelperObject from 'utils/helper-object'
import HelperDate, { dateFormat } from 'utils/helper-date'

export default class FetchCachedBookingInvitationSent
{
	static logName = 'FetchCachedBookingInvitationSent';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'invitations_sent',
				tables: [ 'my_invitations_sent' ],
				onExpire: FetchCachedBookingInvitationSent.reload,
				updated_at_max_age: ( 2 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};
	
	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null, dispatchDataToStore = true } = {} ) => {
		this.construct()
		    .then( () => {
		        return (
		            FetchCache.sniff( this.cacheUpdatedAt, {
			    onFresh: () => {
				    if ( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					    callbackSuccess( this.values )
				    }
			    },
			    onExpired: () => {
				    this.reload( {
					    callbackSuccess,
					    callbackError,
					    callbackStart
				    } )
			    }
		            } )
		        );
		    } );
	}

	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null, dispatchDataToStore = false } = {} ) => {
		const bookingDate = HelperDate.date().subtract(7, 'days').format( dateFormat.DATE ) + '_after_equal'
		
		this.construct().then( () =>
			{
			return (
				FetchBookingInvitationSent.fetchAll({
					bookingDate: bookingDate,
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( { invitations = null } ) => {

						// Save to object
						this.process( invitations );

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, invitations, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( {
								invitations: invitations,
							} );
						}
					}
				})
			);
		}
		);
	}
	
	static process = ( employeeInvitations ) => {
		this.values = employeeInvitations;
		
		// Add a sort by key
		_.forEach( this.values, item => {
			item.sort_by = _.first( item.booking_dates );
		})
		
		store.dispatch( setData( dataConstants.INVITATIONS_SENT, HelperObject.groupByGuid( this.values ) ) );
		store.dispatch( setData( dataConstants.INVITATIONS_SENT_COUNT, _.size( this.values  ) ) );
	}
}
